import { isEmpty } from 'lodash';
import tmsApi from './../api/tmsApi';
import helper from './helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    answer_sets: [],
    query: {
      search: '',
      company_id: null,
      status_filter_or: [],
      page: {
        lastData: null,
        count: 10,
      },
      sort: {
        by: 'CREATED_AT',
        direction: 'DESC',
      },
    },
    detailDataId: null,
    detailData: null,
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.answer_sets.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.answer_sets.push(data);
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.answer_sets.findIndex(prestart => prestart.id === id);
      state.answer_sets.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    SET_COMPANY_ID(state, id) {
      state.query.company_id = id;
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.status_filter_or = [];
      query.page.lastData = null;
      query.page.count = 10;
      query.sort.by = 'CREATED_AT';
      query.sort.direction = 'DESC';
    },
    SET_QUERY_LAST_DATA({ query }, data) {
      query.page.lastData = data;
    },
    SET_TYPE_FILTER(state, types) {
      state.query.status_filter_or.splice(0);
      types.forEach((type) => {
        state.query.status_filter_or.push(type);
      });
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.search = search;
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
  },
  getters: {
    answer_sets(state) {
      return state.answer_sets;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
  },
  actions: {
    LOAD_DATA({ commit, state, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const { lastData, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const typeFilter = state.query.status_filter_or;
      const limit = count;
      let after = '';
      let before = '';
      let skip = '';

      const typeValue = !isEmpty(typeFilter) ?
        `status_filter_or: [${typeFilter.join(', ')}]` : '';

      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      if (lastData !== null) {
        skip = `
          skip: {
            by: ID
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          answer_sets(
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip},
            ${companyId}
            ${typeValue}
          ) {
            id
            company {
              id
              name
            }
            driver {
              id
              name
            }
            vehicle {
              id
              reg_no
            }
            status
            created_at
            answers {
              status
              question_prestart {
                id
                name
                question
                type
              }
              answer
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'answer_sets').then(({ data }) => {
        const { answer_sets } = data;
        answer_sets.forEach((dt) => {
          commit('ADD_DATA_ON_LIST', dt);
        });
      });
    },
    FIND_DATA({ commit, state, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const { lastData, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const statusFilter = state.query.status_filter_or;
      const limit = count;
      let after = '';
      let before = '';
      let skip = '';

      const statusValue = !isEmpty(statusFilter) ?
        `status_filter_or: [${statusFilter.join(', ')}]` : '';

      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      if (lastData !== null) {
        skip = `
          skip: {
            by: ID
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          answer_sets: find_answer_sets(
            query: "${state.query.search}",
            limit: ${limit},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${skip},
            ${companyId}
            ${statusValue}
          ) {
            id
            company {
              id
              name
            }
            driver {
              id
              name
            }
            vehicle {
              id
              reg_no
            }
            status
            created_at
            answers {
              status
              question_prestart {
                id
                name
                question
                type
              }
              answer
            }
          }
        }
      `;
      commit('CLEAR_DATA');
      return api(query, 'find_answer_sets').then(({ data }) => {
        const { answer_sets } = data;
        answer_sets.forEach((dt) => {
          commit('ADD_DATA_ON_LIST', dt);
        });
      });
    },
    DELETE_DATA({ commit, rootState }, prestartId) {
      const api = tmsApi.build(rootState.token);
      const mutation = `mutation {
        deleted: delete_prestart(id: ${prestartId})
      }`;

      return api(mutation, 'delete_prestart').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', prestartId);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.build(rootState.token);
      const query = `{
        answer_set(id: ${state.detailDataId}) {
          id
          company {
            id
            name
          }
          driver {
            id
            name
          }
          vehicle {
            id
            reg_no
          }
          status
          created_at
          answers {
            status
            question_prestart {
              id
              name
              question
              type
            }
            answer
            metadata
          }
        }
      }`;
      return api(query, 'answer_set').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.answer_set);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const {
        name,
        question,
        type,
        required,
        error_text,
        metadata,
        company,
      } = payloads;

      const query = `
        mutation CreateUpdatePrestart($input: PrestartCreateInput) {
          prestart: create_prestart(input: $input) {
            id
            name
            question
            type
            error_text
            required
            metadata
            company {
              id
              name
            }
          }
        }
      `;
      const variables = {
        input: {
          company_id: company.id,
          name,
          question,
          type,
          required,
          error_text,
          metadata,
        },
      };

      return api({
        query,
        variables,
      }, 'create_prestart').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.prestart);
        return data.prestart;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
        return false;
      });
    },
    UPDATE_DATA({ commit, rootState, state }, payloads) {
      const { detailDataId: id } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const query = `
        mutation CreateUpdatePrestart($id: ID!, $input: PrestartUpdateInput) {
          prestart: update_prestart(id: $id, input: $input) {
            id
            name
            question
            type
            error_text
            required
            metadata
            company {
              id
              name
            }
          }
        }
      `;

      const {
        name,
        question,
        type,
        required,
        error_text,
        metadata,
        company,
      } = payloads;

      const variables = {
        id,
        input: {
          company_id: company.id,
          name,
          question,
          type,
          required,
          error_text,
          metadata,
        },
      };

      return api({
        query,
        variables,
      }, 'update_prestart').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.prestart);
        return data.prestart;
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
        return false;
      });
    },
    LOAD_PRESTART_VEHICLE({ rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token);
      const { vehicle_id } = payloads;
      const query = `
      {
        prestarts: get_vehicle_prestart_checklist(vehicle_id: ${vehicle_id}) {
          id
          name
          question
          type
          required
          error_text
          metadata
          company{
            id
            name
          }
        }
      }`;
      return api(query, 'vehicle_prestarts').then(({ data }) => {
        const { prestarts } = data;
        return prestarts;
      });
    },
    LOAD_DATA_BY_COMPANY({ rootState }, payloads) {
      const api = tmsApi.buildRetry(rootState.token);
      const { company_id } = payloads;
      const query = `
      {
        prestarts(company_id: ${company_id}) {
          id
          name
          question
          type
          required
          error_text
          metadata
          company{
            id
            name
          }
        }
      }`;
      return api(query, 'company_prestarts').then(({ data }) => {
        const { prestarts } = data;
        return prestarts;
      });
    },
    ASSIGN_PRESTART_VEHICLE({ rootState }, payloads) {
      const api = tmsApi.build(rootState.token);
      const { vehicle_id, prestart_checklist_ids } = payloads;
      const query = `
      mutation {
        assign: assign_multiple_prestart_vehicle(
          vehicle_id: ${vehicle_id},
          prestart_checklist_ids: [${prestart_checklist_ids}]
        )
      }`;
      return api(query, 'assign_vehicle_prestarts').then(({ data }) => {
        const { assign } = data;
        return assign;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/question_prestart.js